import PartDestination from '@/models/PartDestination/PartDestination';

export default class PartDestinationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.customerId  = '';
		this.customerCode = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.destinationId  = '';
		this.destinationCode = '';
		this.vendorId  = '';
		this.vendorCode = '';
		this.vendorName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			customerId : '0',
			customerCode : '0',
			partId : '0',
			partPartNumber : '0',
			destinationId : '0',
			destinationCode : '0',
			vendorId : '0',
			vendorCode : '0',
			vendorName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}